// Thin typed wrapper over InputSelect for the dashboard range/role pickers: hides the check
// icon (segmented look) and keeps the value typed to the section's literal union.
import React from 'react';
import InputSelect from '@components/ringil3/Input/InputSelect/InputSelect.tsx';

interface DashboardSelectProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { code: T; label: string }[];
}

function DashboardSelect<T extends string>({ value, onChange, options }: DashboardSelectProps<T>) {
  return <InputSelect showCheckIcon={false} selectedItemCode={value} onSelect={code => onChange(code as T)} model={options} />;
}

export default DashboardSelect;